




























































































import { Component, Vue, Prop } from "vue-property-decorator";
import ObjectSelectSearch from "./object-select-search.vue";
@Component({
  components: {
    ObjectSelectSearch,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any;
  private fangshis: any[] = [
    "日一剂，水煎服",
    "日一剂，冲服",
    "日一剂，灌肠",
    "日一剂，外用",
    "日一剂，热敷",
  ];
  private hashKey: any = new Date().getTime();
  private get c() {
    if (this.content) {
      return JSON.parse(JSON.stringify(this.content));
    } else {
      return {
        value: {
          饮片: [{}],
        },
      };
    }
  }
  private valueChange() {
    this.$emit("update", this.c);
  }
  /**
   * @description 删除一个
   */
  private deleteOne(i: any) {
    this.c["value"]["饮片"].splice(i, 1);
    if (this.c["value"]["饮片"].length === 0) {
      this.c["value"]["饮片"].push({});
    }
    this.valueChange();
  }
  /**
   * @description 增加一个
   */
  private addOne() {
    this.c["value"]["饮片"].push({});
    this.valueChange();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.hashKey = new Date().getTime();
  }
}
